/**
 * VIEWER collapsed surface — the only content (besides the welcome header)
 * a `VIEWER` role sees on `/dashboard`. Issues no API calls; displays a
 * static read-only message.
 *
 * Spec 4 / Group 9c — "VIEWER dashboard is intentionally collapsed".
 */
export function ViewerReadOnlyHint() {
	return (
		<div className="rounded-md border border-gray-200 bg-gray-50 px-4 py-6 text-center text-sm text-gray-600">
			You have read-only access. No additional actions are available.
		</div>
	)
}
